import { NgClass } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { BaseComponent } from "../base-component/base.component";

@Component({
    selector: "rask-button",
    styleUrls: ["./button.component.scss"],
    templateUrl: "./button.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class ButtonComponent extends BaseComponent implements OnInit {
    @ViewChild("content", { read: ElementRef,
        static: true }) content: ElementRef;
    @Input() form?: string;
    @Input() icon: string;
    iconOnly = false;
    @Input() selected: boolean;
    @Input() type = "button";

    protected readonly cdRef = inject(ChangeDetectorRef);

    @HostBinding("attr.disabled") get getDisabledState() { return (this.disabled ? "" : null);}

    ngOnInit(): void {
        this.iconOnly = this.content?.nativeElement.childNodes.length === 0;
        super.ngOnInit();
    }

    setType(type: string) {
        this.type = type;
    }
}
